import clsx from "clsx";
import { useSetAtom } from "jotai";
import { FC, ReactNode } from "react";
import { NavLink } from "react-router";
import { navbarAtom } from "../../lib/atoms";

interface Props {
  label: string;
  to: string;
  icon: ReactNode;
}

const MenuLink: FC<Props> = ({ icon, label, to }) => {
  const setNavbar = useSetAtom(navbarAtom);

  return (
    <NavLink
      to={to}
      end={to === "/"}
      onClick={() => setNavbar(false)}
      className={({ isActive }) =>
        clsx(
          "group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200",
          isActive
            ? "bg-orange-50 text-orange-700"
            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        )
      }
    >
      {({ isActive }) => (
        <>
          {/* Indicateur d'onglet actif */}
          <span
            className={clsx(
              "absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-orange-500 transition-all duration-200",
              isActive ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"
            )}
          />
          <span
            className={clsx(
              "flex h-5 w-5 shrink-0 items-center justify-center transition-colors duration-200",
              isActive
                ? "text-orange-600"
                : "text-slate-400 group-hover:text-slate-600"
            )}
          >
            {icon}
          </span>
          <span className="truncate">{label}</span>
        </>
      )}
    </NavLink>
  );
};

export default MenuLink;
